export const field = function (type,val){
	    var fieldList = [];
        if(type=='fieldList'){
        	fieldList=[
        		{
        			"fieldname": "cityid",
        			"fieldother":'cityname',
        			"fieldtitle": "出发地",
        			"fieldtype": "arealist",
        			"fieldmemo": "请选择出发地",
        			"required": 1,
        			"fieldoption": []
        		}, 
        		{
        			"fieldname": "tocityid",
        			"fieldother":'tocityname',
        			"fieldtitle": "目的地",
        			"fieldtype": "arealist",
        			"fieldmemo": "请选择目的地",
        			"required": 1,
        			"fieldoption": [],
        		},
        	    {
        	    	"fieldname": "distance",
        	    	"fieldother":'distance',
        	    	"fieldtitle": "目的地",
        	    	"fieldtype": "arealist",
        	    	"fieldmemo": "请选择目的地",
        	    	"required": 1,
        	    	"fieldoption": [],
        	    },
        		{
        			"fieldname": "goodsname",
        			"fieldtitle": "货物名称 ",
        			"fieldtype": "input",
        			"fieldmemo": "请输入货物名称",
        			"required": 1,
        		},
        		{
        			"fieldname": "goodsweight",
        			"fieldtitle": "重量",
        			"fieldtype": "number",
        			"fieldmemo": "请输入重量",
        			"required": 0,
        			"fieldunit":"吨"
        		},
        		{
        			"fieldname": "goodsload",
        			"fieldtitle": "装货时间 ",
        			"fieldtype": "datelist",
        			"fieldmemo": "请选择装货时间",
        			"required": 1,
        			"fieldoption": [],
        		},
        		{
        			"fieldname": "finishdatetext",
        			"fieldother":'finishdateline',
        			"fieldtitle": "截止时间",
        			"fieldtype": "datelist",
        			"fieldmemo": "请选择截止时间",
        			"required": 0,
        			"fieldoption": [],
        		},
        		{
        			"fieldname": "goodsfare",
        			"fieldtitle": "预算费用",
        			"fieldtype": "number",
        			"fieldmemo": "请输入预算费用",
        			"required": 0,
        			"fieldunit":"元"
        		},
        		{
        			"fieldname": "goodsextend",
        			"fieldtitle": "是否带锤",
        			"fieldtype": "list",
        			"fieldmemo": "请选择是否带锤",
        			"required": 0,
        			"fieldoption": '带锤,不带锤',
        		},
        		{
        			"fieldname": "brief",
        			"fieldtitle": "补充说明",
        			"fieldtype": "content",
        			"fieldmemo": "请输入补充说明",
        			"required": 0,
        		},
        		{
        			"fieldname": "imagelist",
        			"fieldtitle": "待运货物",
        			"fieldtype": "image",
        			"fieldmemo": "请选择是否带锤",
        			"required": 0,
        		},
        		{
        			"fieldname": "linkman",
        			"fieldtitle": "货主姓名 ",
        			"fieldtype": "input",
        			"fieldmemo": "请输入货主物姓",
        			"required": 1,
        		},
        		{
        			"fieldname": "linktel",
        			"fieldtitle": "联系方式 ",
        			"fieldtype": "int",
        			"fieldmemo": "请输入联系方式",
        			"required": 1,
        		},
        	]
        }else if(type=='fieldwl'){
			fieldList=[
				{
					"fieldname": "cityaddr",
					// "fieldother":['address','citylat','longitude'],
					"fieldtitle": "出发地",
					"fieldtype": "map",
					"fieldmemo": "请选择出发地",
					"required": 1,
                    
					"fieldoption": []
				}, 
				{
					"fieldname": "tocityaddr",
					// "fieldother":['address','latitude','longitude'],
					"fieldtitle": "目的地",
					"fieldtype": "map",
					"fieldmemo": "请选择目的地",
					"required": 1,
					"fieldoption": [],
				},
			    {
			    	"fieldname": "distance",
			    	"fieldother":'distance',
			    	"fieldtitle": "运输里程",
			    	"fieldtype": "input",
			    	"fieldmemo": "请输入运输里程",
			    	"required": 1,
			    	"fieldoption": [],
                    "fieldunit":"公里"
			    },
				{
					"fieldname": "goodsname",
					"fieldtitle": "车辆",
					"fieldtype": "list",
					"fieldmemo": "请输入车辆",
					"required": 1,
			        "fieldoption": '牵引车头,载货车,汽车起重机,泵车,自卸车,搅拌车',
				},
				{
					"fieldname": "goodscode",
					"fieldtitle": "车辆型号",
					"fieldtype": "input",
					"fieldmemo": "请输入车辆型号",
					"required": 0,
					"fieldunit":""
				},
                {
                	"fieldname": "framecode",
                	"fieldtitle": "车架号",
                	"fieldtype": "input",
                	"fieldmemo": "请输入车架号",
                	"required": 0,
                	"fieldunit":""
                },
                {
                	"fieldname": "licencecode",
                	"fieldtitle": "临时牌照",
                	"fieldtype": "input",
                	"fieldmemo": "请输入临时牌照",
                	"required": 0,
                	"fieldunit":""
                },
				{
					"fieldname": "startdatetext",
					"fieldtitle": "发车时间",
					"fieldtype": "datelist",
					"fieldmemo": "请选择发车时间",
					"required": 1,
					"fieldoption": [],
				},
				{
					"fieldname": "goodsfare",
					"fieldtitle": "运费",
					"fieldtype": "number",
					"fieldmemo": "请输入运费",
					"required": 1,
					"fieldunit":"元"
				},
				{
					"fieldname": "goodsextend",
					"fieldtitle": "运输原料总量",
					"fieldtype": "input",
					"fieldmemo": "请输入运输原料总量",
					"required": 0,
					"fieldunit":"吨"
				},
				{
					"fieldname": "imagelist",
					"fieldtitle": "详细资料",
					"fieldtype": "image",
					"fieldmemo": "请上传详细资料",
                    "remarks":"(请上传合格证、发票复印件、临牌、保单、使用说明书、维修说明书、钥匙等照片)",
					"required": 0,
				},
				{
					"fieldname": "receivermobile",
					"fieldtitle": "收货人电话 ",
					"fieldtype": "number",
					"fieldmemo": "请输入收货人电话",
					"required": 1,
				},
                {
                	"fieldname": "goodsfeeway",
                	"fieldtitle": "结算方式",
                	"fieldtype": "list",
                	"fieldmemo": "请选择结算方式",
                	"required": 1,
                    "fieldoption": '现结,押后半个月结,其它结算方式',
                },
			]
		}else if(type=="data"){
			fieldList=['全天','上午','下午','00点','01点','02点','03点','04点','05点','06点','07点','08点','09点','10点','11点','12点','13点','14点','15点','16点','17点','18点','19点','20点','21点','22点','23点']
		}else if(type=="datas"){
			fieldList=['00点','01点','02点','03点','04点','05点','06点','07点','08点','09点','10点','11点','12点','13点','14点','15点','16点','17点','18点','19点','20点','21点','22点','23点']
		}else if(type=='attestation'){
			fieldList = [
				{fieldname: 'realname',fieldtitle: '姓名',fieldtype: 'input',required: 1,fieldmaxlen: 0,fieldmemo: '请输入真实姓名',fieldunit:''},
				{fieldname: 'usercardid',fieldtitle: '身份证号',fieldtype: 'input',required: 0,fieldmaxlen: 0,fieldmemo: '请输入身份证号',fieldunit:''},
				{
					fieldname: 'imagelist',
					fieldtitle: '上传身份证照片',
					fieldtype: 'imageID',
					required: 0,
					fieldmaxlen: 0,
					fieldmemo: '',
					fieldoption:[
						{img:"static/images/others/MBP/tgjmbp/author_forward.jpg",title:'身份证正面照'},
						{img:"static/images/others/MBP/tgjmbp/author_background.jpg",title:'身份证反面照'},
					],
					fieldunit:'',
				}
			]
		}else if(type=='step'){
            var inputName=
            {
            	"fieldname": "realname",
            	"fieldtitle": "真实姓名",
            	"fieldtype": "input",
            	"fieldmemo": "请输入真实姓名",
            	"required": 1,
            };
            var inputToUser=
            {
            	"fieldname": "realname",
            	"fieldtitle": "代理人姓名",
            	"fieldtype": "input",
            	"fieldmemo": "请输入代理人姓名",
            	"required": 1,
            };
            var inputCompanyName=
            {
            	"fieldname": "corpname",
            	"fieldtitle": "公司名称",
            	"fieldtype": "input",
            	"fieldmemo": "请输入公司名称",
            	"required": 1,
            };
            var inputIDCard=
            {
            	"fieldname": "usercardid",
            	"fieldtitle": "身份证号",
            	"fieldtype": "input",
            	"fieldmemo": "请输入身份证号",
            	"required": 1,
            };
            var inputToIDCard=
            {
            	"fieldname": "usercardid",
            	"fieldtitle": "代理人身份证",
            	"fieldtype": "input",
            	"fieldmemo": "请输入对代理姓名身份证号码",
            	"required": 1,
            };
            var inputCompanyTel=
            {
            	"fieldname": "corptel",
            	"fieldtitle": "公司电话",
            	"fieldtype": "input",
            	"fieldmemo": "请输入公司电话",
            	"required": 1,
            };
            var imgCard=
            {
            	"fieldname": "userimage1",
            	"fieldtitle": "身份证正面照",
            	"fieldtype": "image",
            	"fieldmemo": "请上传身份证正面照",
            	"required": 1,
                "empty":"https://img.tgj168.com/static/images/others/kyh/userimage1.png"
            };
            var imgCardB=
            {
            	"fieldname": "userimage2",
            	"fieldtitle": "身份证反面照",
            	"fieldtype": "image",
            	"fieldmemo": "请上传身份证反面照",
            	"required": 1,
                "empty":"https://img.tgj168.com/static/images/others/kyh/userimage5.png"
            };
            var imgLicence=
            {
            	"fieldname": "userimage3",
            	"fieldtitle": "营业执照",
            	"fieldtype": "image",
            	"fieldmemo": "请上传营业执照",
            	"required": 1,
                "empty":"https://img.tgj168.com/static/images/others/kyh/userimage3.png"
            };
            var imgDriver=
            {
            	"fieldname": "userimage4",
            	"fieldtitle": "驾驶证正面照",
            	"fieldtype": "image",
            	"fieldmemo": "请上传驾驶证正面照",
            	"required": 1,
                "empty":"https://img.tgj168.com/static/images/others/kyh/userimage4.png"
            };
            fieldList=[
                {
                    title: '个人司机',
                    usertype: 11,
                    top: [inputName, inputIDCard],
                    bottom: [imgCard, imgCardB, imgDriver]
                }, {
                    title: '车队长',
                    usertype:12,
                    top: [inputName, inputIDCard],
                    bottom: [imgCard, imgCardB, imgDriver]
                }, 
                {
                    title: '物流公司',
                    usertype:31,
                    top: [inputCompanyName,inputToUser,inputToIDCard],
                    bottom: [imgCard, imgCardB,imgLicence]
                },
                {
                    title: '个体户',
                    usertype:21,
                    top: [inputName, inputIDCard],
                    bottom: [imgCard, imgCardB]
                }, {
                    title: '企业',
                    usertype:22,
                    top: [inputCompanyName,inputToUser,inputToIDCard],
                    bottom: [imgCard, imgCardB,imgLicence]
                }, 
              
            ]
        } else if(type=='finance'){
            fieldList=[{
                title: '结算总价',
                price:'price1',
            }, {
                title: '运程总油费',
                price:'price2',
            }, {
                title: '司机人力运输费用',
                price:'price3',
            }, {
                title: '尿素费',
                price:'price4',
            }, {
                title: '临时加油费',
                price:'price5',
            }, {
                title: '补漆费用',
                price:'price6',
            }, {
                title: '车队长佣金',
                price:'price7',
            } ]
        }else if(type=='followup'){
            fieldList=[
            	{
            		"fieldname": "goodsname",
            		"fieldtitle": "车辆",
            		"fieldtype": "list",
            		"fieldmemo": "请输入车辆",
            		"required": 1,
            	    "fieldoption": '牵引车头,载货车,汽车起重机,泵车,自卸车,搅拌车',
            	},
                {
                	"fieldname": "goodsname",
                	"fieldtitle": "车辆",
                	"fieldtype": "list",
                	"fieldmemo": "请输入车辆",
                	"required": 1,
                    "fieldoption": '牵引车头,载货车,汽车起重机,泵车,自卸车,搅拌车',
                },
            	{
            		"fieldname": "imagelist",
            		"fieldtitle": "详细资料",
            		"fieldtype": "image",
            		"fieldmemo": "请上传详细资料",
                    "remarks":"(请上传合格证、发票复印件、临牌、保单、使用说明书、维修说明书、钥匙等照片)",
            		"required": 0,
            	},
            	{
            		"fieldname": "brief",
            		"fieldtitle": "补充说明",
            		"fieldtype": "content",
            		"fieldmemo": "请输入补充说明",
            		"required": 0,
            	},
            ]
        }else if(type=='draft'){
            fieldList=[
                {
                	"fieldname": "imagelist",
                	"fieldtitle": "上传票据",
                	"fieldtype": "image",
                	"fieldmemo": "请上传票据",
                    "remarks":"",
                	"required": 1,
                    "empty":'http://tgj168.com/static/images/mapp/common/upload/imageupload.png'
                },
            	{
            		"fieldname": "draftname",
            		"fieldtitle": "承兑人名称",
            		"fieldtype": "input",
            		"fieldmemo": "请输入承兑人名称",
            		"required": 1,
            	    "fieldoption": '',
            	},
                {
                	"fieldname": "draftmoney",
                	"fieldtitle": "票面金额",
                	"fieldtype": "input",
                	"fieldmemo": "请输入票面金额",
                	"required": 1,
                    "fieldoption": '',
                    // "fieldunit":"万元"
                },
                {
                	"fieldname": "draftcode",
                	"fieldtitle": "票据号码",
                	"fieldtype": "input",
                	"fieldmemo": "请输入票据号码",
                	"required": 1,
                    "fieldoption": '',
                    
                },
                {
                	"fieldname": "draftenddate",
                	"fieldtitle": "到期日期",
                	"fieldtype": "time",
                	"fieldmemo": "请输入到期日期",
                	"required": 1,
                    "fieldoption": '',
                },
                {
                	"fieldname": "draftflaw",
                	"fieldtitle": "瑕疵",
                	"fieldtype": "radio",
                	"fieldmemo": "请选择瑕疵",
                	"required": 0,
                    "fieldoption": ['无瑕疵','回出票人aba','回出票人abca','回收款人','背书重复','abb','质押','保证','上下不一致'],
                },
                {
                	"fieldname": "mindprice",
                	"fieldtitle": "意向一口价 	",
                	"fieldtype": "input",
                	"fieldmemo": "请输入意向一口价",
                	"required": 0,
                    "fieldoption": '',
                },
            	
            ]
        }else if(type=='fbxq'){
            fieldList=[
            	{
            		"fieldname": "draftmoney",
            		"fieldtitle": "购买金额",
            		"fieldtype": "input",
            		"fieldmemo": "请输入购买金额",
            		"required": 1,
            	    "fieldoption": '',
                    "fieldunit":"万元"
            	},
                {
                	"fieldname": "draftdate",
                	"fieldtitle": "到期日",
                	"fieldtype": "list",
                	"fieldmemo": "请选择到期日",
                	"required": 1,
                    "fieldoption": '1个月,3个月,6个月,9个月,12个月',
                },
                {
                	"fieldname": "draftbuyer",
                	"fieldtitle": "购买者",
                	"fieldtype": "radio1",
                	"fieldmemo": "请选择购买者",
                	"required": 1,
                    "fieldoption":  ['公司','个人'],
                },
            	{
            		"fieldname": "usermobile",
            		"fieldtitle": "联系电话",
            		"fieldtype": "input",
            		"fieldmemo": "请输入联系电话",
            		"required": 0,
            	    "fieldoption":  '',
            	},
            ]
        }else if(type=='bank'){
            fieldList=[
                {
                    "fieldname": "realname",
                    "fieldtitle": "姓名",
                    "fieldtype": "input",
                    "fieldmemo": "请输入持卡人姓名",
                    "required": 1,
                    "fieldoption": '',
                },
                {
                    "fieldname": "usercardid",
                    "fieldtitle": "身份证号",
                    "fieldtype": "input",
                    "fieldmemo": "请输入持卡人身份证号",
                    "required": 1,
                    "fieldoption": '',
                },
                {
                    "fieldname": "userbankcid",
                    "fieldtitle": "银行卡号",
                    "fieldtype": "inputimage",
                    "fieldmemo": "请输入银行卡号",
                    "required": 1,
                    "fieldoption": '',
                },
            ]
        }else if(type=='businessimg'){
            fieldList=[
                {
                    "fieldname": "corpimage",
                    "fieldtitle": "营业执照",
                    "fieldtype": "imageAttestation",
                    "fieldmemo": "请上传营业执照",
                    "required": 1,
                    "fieldoption": '',
                    "empty":val==1?require('../assets/draft/attestation/step_2_qy.png'):require('../assets/draft/attestation/step_2_gr.png'),
                    "fieldurl":'d=wxapi&c=common_tools&m=ocr_license',
                },
            ]
            
        }else if(type=='userimage'){
            fieldList=[
                {
                    "fieldname": "userimage",
                    "fieldtitle": "身份证正面照片",
                    "fieldtype": "imageAttestation",
                    "fieldmemo": "请上传身份证正面照片",
                    "required": 1,
                    "fieldoption": '',
                    "empty":require('../assets/draft/attestation/step_2_1.png'),
                    "fieldurl":'d=wxapi&c=common_tools&m=ocr_idcard'
                },
                {
                    "fieldname": "userimage1",
                    "fieldtitle": "身份证反面照片",
                    "fieldtype": "imageAttestation",
                    "fieldmemo": "请上传身份证反面照片",
                    "required": 1,
                    "fieldoption": '',
                    "empty":require('../assets/draft/attestation/step_2_2.png'),
                    "fieldurl":'',
                },
            ]
        }else if(type=='business'){
            fieldList=[
                {
                    "fieldname": "corpname",
                    "fieldtitle": val==1?"企业名称":"商户名称",
                    "fieldtype": "input",
                    "fieldmemo": val==1?"请输入企业名称":"请输入商户名称",
                    "required": 1,
                    "fieldoption": '',
                },
                {
                    "fieldname": "corpcode",
                    "fieldtitle": "统一社会信用代码",
                    "fieldtype": "input",
                    "fieldmemo": "请输入统一社会信用代码",
                    "required": 1,
                    "fieldoption": '',
                },
                {
                    "fieldname": "corpcityname",
                    "fieldother": "corpcityid",
                    "fieldtitle": "注册地区 ",
                    "fieldtype": "arealist",
                    "fieldmemo": "请选择注册地区",
                    "required": 1,
                    "fieldoption": '',
                },
                {
                    "fieldname": "corpaddress",
                    "fieldtitle": "详细地址",
                    "fieldtype": "input",
                    "fieldmemo": "请输入详细地址",
                    "required": 1,
                    "fieldoption": '',
                },
                {
                    "fieldname": "corpserveinfo",
                    "fieldtitle": "经营范围",
                    "fieldtype": "input",
                    "fieldmemo": "请输入经营范围",
                    "required": 1,
                    "fieldoption": '',
                },  
                {
                    "fieldname": "corpstartdate",
                    "fieldohter": "corpenddate",
                    "fieldtitle": "营业时间",
                    "fieldtype": "times",
                    "fieldmemo": "请选择营业时间",
                    "required": 1,
                    "fieldoption": '',
                },  
            ]
        }else if(type=='bankinfo'){
            if(val==1){
                fieldList=[
                    {
                        "fieldname": "bankname",
                        "fieldtitle": "开户银行 ",
                        "fieldtype": "input",
                        "fieldmemo": "请输入开户银行 ",
                        "required": 1,
                        "fieldoption": '',
                    },
                    {
                        "fieldname": "bankbranch",
                        "fieldtitle": "开户支行",
                        "fieldtype": "input",
                        "fieldmemo": "请输入开户支行",
                        "required": 1,
                        "fieldoption": '',
                    },
                    {  
                        "fieldname": "bankcardid",
                        "fieldtitle": "银行账号",
                        "fieldtype": "input",
                        "fieldmemo": "请输入银行账号",
                        "required": 1,
                        "fieldoption": '',
                    },
                ]
            }else{
                fieldList=[
                    {  
                        "fieldname": "bankcardid",
                        "fieldtitle": "银行账号",
                        "fieldtype": "input",
                        "fieldmemo": "请输入银行账号",
                        "required": 1,
                        "fieldoption": '',
                    },
                    {
                        "fieldname": "bankusermobile",
                        "fieldtitle": "银行预留手机",
                        "fieldtype": "input",
                        "fieldmemo": "请输入银行预留手机",
                        "required": 1,
                        "fieldoption": '',
                    },
                ]
            }
        }else if(type=='personalinfo'){
            fieldList=[
                {
                    "fieldname": "realname",
                    "fieldtitle": "姓名 ",
                    "fieldtype": "input",
                    "fieldmemo": "请输入姓名",
                    "required": 1,
                    "fieldoption": '',
                },
                {
                    "fieldname": "usercardid",
                    "fieldtitle": "证件号码",
                    "fieldtype": "input",
                    "fieldmemo": "请输入证件号码",
                    "required": 1,
                    "fieldoption": '',
                },
                {  
                    "fieldname": "usercardstart",
                    "fieldohter": "usercardend",
                    "fieldtitle": "证件有效期",
                    "fieldtype": "times",
                    "fieldmemo": "请选择证件有效期",
                    "required": 1,
                    "fieldoption": '',
                },
            ]
        }else if(type=='contact'){
            fieldList=[
                {
                    "fieldname": "usermobile",
                    "fieldtitle": "手机号",
                    "fieldtype": "int",
                    "fieldmemo": "请输入手机号",
                    "fieldmaxlen": 11,
                    "required": 1,
                    "fieldoption": '',
                },
            ]
        }
	    return fieldList;
}